import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appXIPopoutContent]',
  standalone: false,
})
export class XiPopoutContentDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
